import {partsLinkAccess} from './parts-link-access-en.i18n'

export const en = {partsLinkAccess}
